import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, ListItemIcon, ListItemText, Typography, ListItemSecondaryAction } from '@material-ui/core';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import UserAvatar from './user-avatar'
import ExirioStyles from '../../utils/exirioStyles'

const useStyles = makeStyles((theme) => ({
    pureWhiteText: {
        color: ExirioStyles.pureWhiteText,
    },
    avatar: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        color: ExirioStyles.pureWhiteText,
    },
    userEmail: {
        whiteSpace: 'break-spaces',
        wordWrap: 'break-word',
        fontSize: 13,
        lineHeight: '15px',
        color: ExirioStyles.secondaryWhiteText
    },
    icon: {
        fontSize: '26px',
        paddingLeft: theme.spacing(1)
    },
    iconRed: {
        color: ExirioStyles.errorRed,
        fontSize: '26px',
        paddingLeft: theme.spacing(1)
    },
    active: {
        background: ExirioStyles.tableTint
    }
}));

export default function UserListItem(props) {
    const {user, onChange, isCurrentUser, isActive} = props;
    const classes = useStyles();

    return (
        <ListItem className={isActive ? classes.active : ''} button onClick={() => onChange(user)}>
            <ListItemIcon>
                <UserAvatar user={user} className={classes.avatar}/>
            </ListItemIcon>
            <ListItemText 
                primary={<span className={classes.pureWhiteText}>{user?user.name:''}</span>}
                secondary={<Typography variant="body1" className={classes.userEmail}>{user?user.email:''}</Typography>} />
            <ListItemSecondaryAction>
                {
                    isCurrentUser ? 
                    <Typography variant="body1" className={classes.userEmail}>Me</Typography> :
                    <>
                        {
                            user.permission.edit ? 
                            <EditIcon className={classes.icon}/> : 
                            (user.permission.View ? <VisibilityIcon className={classes.icon}/> : false)
                        }
                        {user.permission.emergency ? <LocalHospitalIcon className={classes.iconRed}/> : false}
                    </>
                }
            </ListItemSecondaryAction>
        </ListItem>
    );
}
